<div class="container-fluid bg-primary px-0">
  <div class="row mx-0 align-items-center" style="background-color: #fbd541">
    <!-- Columna de texto -->
    <div
      class="col-12 col-lg-6 px-3 px-md-5 py-4 py-lg-0 text-center text-lg-left"
    >
      <h2
        class="text-uppercase mb-3 title"
        style="font-size: clamp(2rem, 6vw, 4.5rem); line-height: 1.2"
      >
        Consultoría financiera estratégica
      </h2>
      <p class="text-dark mb-4" style="font-size: clamp(1rem, 2vw, 1.5rem)">
        Para individuos, PyMEs y empresas que buscan tomar mejores decisiones,
        acceder a financiamiento o hacer crecer su patrimonio.
      </p>
      <div class="d-flex justify-content-center justify-content-lg-start">
        <button
          (click)="scrollToContact()"
          class="btn btn-dark text-uppercase py-3 px-4 px-lg-5"
          style="font-size: clamp(0.9rem, 1.5vw, 1.1rem)"
          aria-label="Agenda una reunión"
        >
          Agenda una reunión
        </button>
      </div>
    </div>

    <!-- Columna de imagen - visible solo en desktop -->
    <div
      class="col-lg-6 d-none d-lg-flex align-items-center px-0"
      style="min-height: 550px"
    >
      <div class="w-100 h-100 d-flex justify-content-end">
        <picture>
          <source srcset="assets/7.webp" type="image/webp" />
          <img
            class="h-100 w-auto"
            src="assets/7.png"
            alt="Consultoria"
            style="object-fit: contain; object-position: right center"
          />
        </picture>
      </div>
    </div>
  </div>
</div>
<!-- Sección con fondo amarillo -->
<div class="container-fluid p-5">
  <div class="row g-0 align-items-stretch">
    <!-- Columna de imagen -->
    <div class="col-12 col-lg-6 d-flex order-2 order-lg-1">
      <img
        src="assets/8.png"
        class="img-fluid h-auto align-self-center custom-img"
        alt="Asesoría financiera"
        style="object-fit: contain; max-height: 800px"
      />
    </div>

    <!-- Columna de texto con fondo amarillo -->
    <div
      class="col-12 col-lg-6 d-flex order-1 order-lg-2 p-4 p-lg-5"
      style="background-color: #fbd541; min-height: 100%"
    >
      <div class="m-auto w-100">
        <!-- Contenedor interno centrado -->
        <h2
          class="text-uppercase mb-4 title"
          style="font-size: clamp(1.75rem, 4vw, 3.5rem); line-height: 1.3"
        >
          Somos asesores financieros independientes. <br />
          Y te hablamos sin vueltas.
        </h2>
        <p
          class="mb-0"
          style="color: #252525; font-size: clamp(1rem, 1.5vw, 1.25rem)"
        >
          Somos LightCap Group, una firma fundada por agentes del mercado de
          capitales con amplia experiencia en asesoramiento a personas y PyMEs.
          Nuestra misión es ayudarte a planificar, proteger y potenciar tu
          dinero. Sin letra chica, sin productos enlatados, sin conflictos de
          interés.
        </p>
      </div>
    </div>
  </div>
</div>
<app-our-services></app-our-services>
<app-team></app-team>
<app-newsletter></app-newsletter>
<div class="container-fluid py-1">
  <div class="container my-1">
    <h1 class="display-4 text-uppercase text-center">
      Comunicate con nosotros
    </h1>
  </div>
  <div id="contact-form-section">
    <app-contact-form></app-contact-form>
  </div>
</div>
<app-top-up-button></app-top-up-button>
